import { computeAccommodationOfferTotalsView } from 'checkout/lib/utils/accommodation/priceView'
import { addTotals } from 'checkout/lib/utils/payments/totals'
import { createSelector } from 'reselect'
import { sum } from 'lib/array/arrayUtils'
import { checkoutWithMemberPrice, getHasLuxPlusOrSubscriptionInCart } from '../view/luxPlusSubscription'
import { checkoutAccommodationOfferView } from '../view/accommodation'
import { floatify } from 'lib/maths/mathUtils'
import { getIsPostPurchaseTourChangeDates } from 'checkout/selectors/tourV2Selectors'
import getTourV2ItemViews from 'checkout/selectors/view/itemViews/getTourV2ItemViews'

export const getAccommodationTotals = createSelector(
  (state: App.State) => checkoutAccommodationOfferView(state),
  (state: App.State) => checkoutWithMemberPrice(state),
  (state: App.State) => getHasLuxPlusOrSubscriptionInCart(state),
  (state: App.State) => getIsPostPurchaseTourChangeDates(state),
  (offerViewsWithStatus, checkoutWithMemberPrice, hasLuxPlusOrSubscriptionInCart, isPostPurchaseTourDateChange): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const result = offerViewsWithStatus.data.map(view => computeAccommodationOfferTotalsView(view, { checkoutWithMemberPrice, hasLuxPlusOrSubscriptionInCart, isPostPurchaseTourDateChange }))
    return {
      hasRequiredData: offerViewsWithStatus.hasRequiredData,
      data: addTotals(result).data,
    }
  },
)

export const getTourV2Total = createSelector(
  (state: App.State) => getTourV2ItemViews(state),
  (state: App.State) => checkoutWithMemberPrice(state),
  (state: App.State) => getHasLuxPlusOrSubscriptionInCart(state),
  (state: App.State) => getIsPostPurchaseTourChangeDates(state),
  (offerViewsWithStatus, checkoutWithMemberPrice, hasLuxPlusOrSubscriptionInCart, isPostPurchaseTourDateChange): number => {
    const tourOffersView = offerViewsWithStatus.data.map(view => computeAccommodationOfferTotalsView(view, { checkoutWithMemberPrice, hasLuxPlusOrSubscriptionInCart, isPostPurchaseTourDateChange }))
    return sum(tourOffersView, tourOfferView => tourOfferView.data.price)
  },
)

export const getAccommodationTotal = createSelector(
  (state: App.State) => getAccommodationTotals(state),
  (totals): number => {
    const { price = 0, surcharge = 0, otherFees = {} } = totals.data
    return price + surcharge + sum(Object.values(otherFees))
  },
)

export const getDueAtProperty = createSelector(
  (state: App.State) => getAccommodationTotals(state),
  (totals): number => (totals.data.otherFees?.propertyFees || 0) + (totals.data.otherFees?.extraGuestSurcharge || 0),
)

export const getAccommodationPayable = createSelector(
  (state: App.State) => getAccommodationTotals(state),
  (state: App.State) => getDueAtProperty(state),
  (accommodationTotal, dueAtProperty): number => {
    const { price = 0, surcharge = 0, otherFees = {} } = accommodationTotal.data
    return floatify(price + surcharge + sum(Object.values(otherFees)) - dueAtProperty)
  },
)
